<main class="main">
    <div class="container">
        <ng-template  #importModal [ngIf]="missedActionDataImportFormGroup">
            <form [formGroup]="missedActionDataImportFormGroup" autocomplete="off">
                <div class="pageHeader d-flex justify-content-between">
                    <h1 class=" mb-4">Missed Action Data Validation</h1>
                </div>
                <div class="card-body ps-0 pe-0">
                    <div class="d-flex">
                        <div class="form-floating mb-3 mt-3 datePicker col-2" style="margin-left: 25px;">
                            <input type="text" placeholder="Monitoring Date" class="form-control" bsDatepicker
                                [bsConfig]="{ isAnimated: true,dateInputFormat: 'MM/DD/YYYY' }" #s1="bsDatepicker"
                                formControlName="missedActionDataDate" readonly
                                [ngClass]="{ 'is-invalid': urlConfigForm['missedActionDataDate'].invalid && (urlConfigForm['missedActionDataDate'].dirty || urlConfigForm['missedActionDataDate'].touched || isImportFormSubmitted) }">
                            <label for="txtUrl">Missed Action Data Start Date<span class="text-danger">*</span></label>
                            <span class="input-group-text" (click)="s1.toggle()"><i class="fa fa-calendar"></i></span>
                            <div *ngIf="urlConfigForm['missedActionDataDate'].invalid && (urlConfigForm['missedActionDataDate'].dirty || urlConfigForm['missedActionDataDate'].touched || isImportFormSubmitted)"
                                class="error textError">
                                <div *ngIf="urlConfigForm['missedActionDataDate'].errors?.['required']">
                                    Please select missed action data start date
                                </div>
                            </div>
                        </div>
                        <div class="form-floating mb-3 mt-3 datePicker col-2" style="margin-left: 25px;">
                            <input type="text" placeholder="Monitoring Date" class="form-control" bsDatepicker
                                [bsConfig]="{ isAnimated: true,dateInputFormat: 'MM/DD/YYYY' }" #s2="bsDatepicker"
                                formControlName="missedActionDataEndDate" readonly
                                [ngClass]="{ 'is-invalid': urlConfigForm['missedActionDataEndDate'].invalid && (urlConfigForm['missedActionDataEndDate'].dirty || urlConfigForm['missedActionDataEndDate'].touched || isImportFormSubmitted) }">
                            <label for="txtUrl">Missed Action Data End Date<span class="text-danger">*</span></label>
                            <span class="input-group-text" (click)="s2.toggle()"><i class="fa fa-calendar"></i></span>
                            <div *ngIf="urlConfigForm['missedActionDataEndDate'].invalid && (urlConfigForm['missedActionDataEndDate'].dirty || urlConfigForm['missedActionDataEndDate'].touched || isImportFormSubmitted)"
                                class="error textError">
                                <div *ngIf="urlConfigForm['missedActionDataEndDate'].errors?.['required']">
                                    Please select missed action data end date
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="uploadBtnWrapper d-flex" style="margin-left: 25px; margin-top: 20px;">
                        <label class="btn btn-primary uploadBtn">Select File
                            <input type="file" accept=".xls,.xlsx" #missedActionDataFile (change)="SetFile($event)"
                                name="missedActionDataFile" id="missedActionDataFile">
                        </label>
                        <div class="form-floating col-3" style="margin-left: 25px;">
                            <input type='text' placeholder="" id="File" formControlName="missedActionDataFileName"
                                class="form-control mt-0" readonly>
                            <label for="File">File Name<span class="text-danger">*</span></label>
                            <div *ngIf="(missedActionDataImportForm['missedActionDataFile']?.dirty || missedActionDataImportForm['missedActionDataFile']?.touched || isImportFormSubmitted) && missedActionDataImportForm['missedActionDataFile'].errors"
                                class="error textError">
                                <div *ngIf="missedActionDataImportForm['missedActionDataFile'].errors?.['required']">
                                    Please upload file
                                </div>
                                <div *ngIf="missedActionDataImportForm['missedActionDataFile'].errors?.['notSupportedxls']">
                                    You can only upload .xls files
                                </div>
                                <div *ngIf="missedActionDataImportForm['missedActionDataFile'].errors?.['notSupportedXlsSize']">
                                    You can only upload files with maximum 5 MB size
                                </div>
                            </div>
                        </div>
                    </div>
                    <label *ngIf="missedActionDataImportForm['missedActionDataFile'].value === ''" for="File" style="color: red;margin-left: 12%;">Only .xls and .xlsx files are allowed.<span class="text-danger">*</span></label>
                    <div style="margin-top: 40px; margin-left: 10px;">
                        <button class="btn btn-primary smallBtn" (click)="Import(comfirmation)">Upload</button>
                        <button class="btn btn-default smallBtn" style="margin-left: 30px;" [routerLink]="['/MissedActionDataHistory']">Cancel</button>
                    </div>
                </div>
            </form>
        </ng-template>
        <app-loader [showLoader]="showLoader"></app-loader>
        <ng-template #comfirmation>
            <div class="modal-body">
                <div class="row">
                    <div class="col-12 masterIdDetail">
                        <p>File Uploaded Successfully</p>
                        <!-- <p>Client Master ID: {{clientMasterId}}</p> -->
                    </div>
                    <div class="col-12 text-right">
                        <button class="btn btn-primary smallBtn" routerLink="/MissedActionDataHistory" (click)="Close()">OK</button>
                        <!-- <button class="btn btn-default smallBtn" (click)="Close()">Cancel</button> -->
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
</main>
